module.exports = __webpack_public_path__ + "PTMETTAabout-6.23f00e57.png";